import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import heroImage from '../../../../images/hero.jpg';
import './Hero.css';

function Hero() {
  const [eventsCount, setEventsCount] = useState(0);
  const [invitesCount, setInvitesCount] = useState(0);
  const [usersCount, setUsersCount] = useState(0);

  useEffect(() => {
    // Animate statistics on mount
    const animateCount = (target, setter, duration = 2000) => {
      const increment = target / (duration / 16);
      let current = 0;
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          setter(target);
          clearInterval(timer);
        } else {
          setter(Math.floor(current));
        }
      }, 16);
    };

    animateCount(10000, setEventsCount);
    animateCount(50000, setInvitesCount);
    animateCount(5000, setUsersCount);
  }, []);

  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-tag">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 0l1.5 4.5h4.5l-3.5 2.5 1.5 4.5L7 9l-3.5 2.5 1.5-4.5-3.5-2.5h4.5L7 0z" fill="#6C63FF" />
          </svg>
          <span>Trusted by thousands of event planners</span>
        </div>
        <h1 className="hero-title">
          Create Beautiful Event Invitations in <span className="hero-highlight">Minutes</span>
        </h1>
        <p className="hero-description">
          Plan, manage, and share stunning event invitations effortlessly. Track RSVPs in real-time, send personalized messages, and make every event memorable.
        </p>
        <div className="hero-buttons">
          <Link to="/signup" className="hero-btn-primary">
            Get Started Free
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 3l5 5-5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <Link to="/templates" className="hero-btn-secondary">
            Browse Templates
          </Link>
        </div>
        <div className="hero-stats">
          <div className="hero-stat">
            <span className="hero-stat-value">{eventsCount.toLocaleString()}+</span>
            <span className="hero-stat-label">Events Created</span>
          </div>
          <div className="hero-stat-divider"></div>
          <div className="hero-stat">
            <span className="hero-stat-value">{invitesCount.toLocaleString()}+</span>
            <span className="hero-stat-label">Invitations Sent</span>
          </div>
          <div className="hero-stat-divider"></div>
          <div className="hero-stat">
            <span className="hero-stat-value">{usersCount.toLocaleString()}+</span>
            <span className="hero-stat-label">Happy Users</span>
          </div>
        </div>
      </div>
      <div className="hero-image">
        <div className="hero-image-wrapper">
          <img
            src={heroImage}
            alt="Event gathering"
          />
          <div className="hero-image-badge">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="9" fill="#6C63FF" />
              <path d="M6 10l2.5 2.5L14 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <div>
              <span className="hero-badge-title">100% Free</span>
              <span className="hero-badge-subtitle">No credit card required</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
